import { format } from "date-fns"

const formatStartDate = (startDate: Date): string => {
  return format(startDate, "yyyy-MM-dd")
}

export default formatStartDate
